module.exports = __webpack_public_path__ + "static/cat_3-3b6d582bb7c77d5b65d8228d37389464.png";